import { formatValidatedMeasurement } from "../../utils/results/validatedRanges";
import {
  hasMetricValue,
  isMetricPending,
} from "../../utils/results/metricPending";
import ResultPendingDots from "./ResultPendingDots";
import { usePendingTick } from "./usePendingTick";

/**
 * Renders a metric cell: the validated value (+ optional unit), a "Calculating…"
 * indicator when the value is missing but the recording is recent, or the empty
 * fallback ("--") once the pending window has passed / the recording is old.
 */
export default function MetricValue({
  metric,
  value,
  recordingTimestamp,
  unit,
  fallback = "--",
  forcePending = false,
}) {
  const pending = forcePending || isMetricPending(value, recordingTimestamp);

  // Flip Calculating -> fallback exactly when the pending window closes, even if
  // the surrounding data never refreshes.
  usePendingTick(recordingTimestamp, pending);

  if (hasMetricValue(value)) {
    const text = formatValidatedMeasurement(metric, value, fallback);
    return (
      <>
        {text}
        {unit && text !== fallback ? (
          <span className="muted-text"> {unit}</span>
        ) : null}
      </>
    );
  }

  if (pending) {
    return <ResultPendingDots className="muted-text" />;
  }

  return <>{fallback}</>;
}
